import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Utysb { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    DISPLAY: string = '';            // 顯示 0 

    @IsNotEmpty({message: '序號 (ITEM) 不可空白'}) 
    @MaxLength(50,{message: '序號 (ITEM) 資料太長'})
    ITEM: string = '';            // 序號 50 

    @IsNotEmpty({message: '主資料表 (MAINTABLE) 不可空白'}) 
    @MaxLength(50,{message: '主資料表 (MAINTABLE) 資料太長'})
    MAINTABLE: string = '';            // 主資料表 50 

    MAP: string = '';            // WHERE參數設定 0 

    @MaxLength(255,{message: '備註 (PS) 資料太長'})
    PS: string = '';            // 備註 255 

    SB100: string = '';            // 保留1 0 

    SB101: string = '';            // 保留2 0 

    SB102: string = '';            // 保留3 0 

    @MaxLength(255,{message: '保留4 (SB103) 資料太長'})
    SB103: string = '';            // 保留4 255 

    @MaxLength(255,{message: '保留5 (SB104) 資料太長'})
    SB104: string = '';            // 保留5 255 

    @MaxLength(255,{message: '保留6 (SB105) 資料太長'})
    SB105: string = '';            // 保留6 255 

    SQLORDER: string = '';            // 欄位排序 0 

    SQLRETURN: string = '';            // SQLReturn 0 

    SQLSELECT: string = '';            // SQLSelect 0 

    SQLWHERE: string = '';            // SQLWhere 0 

    @MaxLength(50,{message: '標題 (TITLE) 資料太長'})
    TITLE: string = '';            // 標題 50 

    @MaxLength(1,{message: '類別 (TYPE) 資料太長'})
    TYPE: string = '';            // 類別 1 


}
